<template>
	<div class="container-home">
		<div class="gap-bottom">
			<div class="bg-top-v">
				<div class="search-top-wrap">
					<NuxtLink class="search-top flex search-top-link" :to="searchPageRoute" @click="onSearchBarClick">
						<span class="search-input">产品名称/型号规格/厂家/商品描述</span>
						<span class="search-btn">搜索</span>
					</NuxtLink>
				</div>
				<div class="header">
					<SwiperDot ref="swiperDotRef" @click="onSwiperBannerClick" />
				</div>
			</div>
			<ShopNews :newsList="newsList" :noticeList="noticeList" />

			<!-- 金刚位 -->
			<NavigationZone v-if="navigationList.length > 0" :navList="navigationList" @click="onNavigationClick" />

			<!-- 运营广告 -->
			<OperateAdList v-if="operateAdList.length > 0" :AdList="operateAdList" @click="onOperateAdClick" />
			<!--横幅广告-->
			<div class="web-banner-box" v-if="bannerImageUrl">
				<a class="web-banner-link" :href="homeBannerHref" rel="nofollow" @click.prevent="goToLink()">
					<NuxtImg class="web-banner-img" :src="bannerImageUrl" :alt="homeBannerAlt" />
				</a>
			</div>
			<!--运营品位-->
			<div class="operator-grade" v-if="dataList.length > 0">
				<BigImg :dataList="dataList" fromPage="总站首页" @click="clickOperatorGrade" />
			</div>

			<!--品牌中心-->
			<LogoWall v-if="logoList.length > 0" :logoList="logoList" />
		</div>
		<!-- 国械标讯 -->
		<TenderNoticeList :list="tenderNoticeList" @clickMore="onTenderClickMore" @toDetail="onTenderToDetail" />

		<!-- 国械头条 -->
		<TopStoryList :list="topStoryList" @clickMore="onTopStoryClickMore" @toDetail="onTopStoryToDetail" />

		<!-- 猜你喜欢 -->
		<GuessLike v-if="recommendList.length > 0" :dataList="recommendList" fromPage="总站首页" @click="clickGuessLike" />

		<Qualification></Qualification>

		<!-- 底部 TabBar -->
		<footerBar :checks="0" />
		<!-- 回到顶部 -->
		<ClientOnly>
			<GoTop :scrollTop="scrollTop" @tapTop="handleScroll" />
		</ClientOnly>
	</div>
</template>

<script setup>
import { ref, onMounted, computed, onUnmounted, nextTick } from 'vue';
import SwiperDot from './components/swiperDot.vue';
import NavigationZone from './components/NavigationZone.vue';
import OperateAdList from './components/OperateAdList.vue';
import BigImg from '@/components/BigImg.vue';
import LogoWall from './components/LogoWall.vue';
import GuessLike from '@/components/GuessLike.vue';
import ShopNews from './components/ShopNews.vue';
import Qualification from './components/Qualification.vue';
import TenderNoticeList from './components/TenderNoticeList.vue';
import TopStoryList from './components/TopStoryList.vue';
import { handleTenderNoticeJump } from '@/utils/tenderNoticeJump.js';
import {
	getNoticeList,
	getMbKingkongAreaList,
	getMbOperateAdList,
	selectMobileHomeConfig,
	statisticsMenu,
	mbOpSpuQuery,
	getMbBannerAdList,
	queryFloorByThemeIdForMb,
	recommendProducts,
	getHotNews,
	gxzzMallQueryPage,
	searchNotice,
} from '@/api/index';

const { trackEvent, trackEventExposure, disconnectAllExposure } = useAnalytics();
const route = useRoute();
const requestUrl = useRequestURL();

useSeoMeta({
	title: '国械在线-医疗器械互联网供应链服务平台',
	description:
		'国械在线是国药器械针对不同的客户群,以“经营客户”为核心,打造专业的医疗器械B2B电商平台。通过此平台联动医疗器械上中下游全产业链,提高客户服务效率、客户采购体验、解决上下游业务痛点。',
	keywords: '国械在线,国药器械,中国医疗器械',
});

const config = useRuntimeConfig();
const pcBase = (config.public.publicPcUrl || '').replace(/\/$/, '');
const portraitMobileUrl = (config.public.portraitMobileUrl || '').replace(/\/$/, '');

// 生成首页规范地址，忽略所有 query 参数。
const canonicalHref = computed(() => {
	const origin = requestUrl.origin || '';
	const path = route.path || '/';
	return origin ? `${origin}${path}` : path;
});

// 首页 canonical 固定输出无参数标准地址。
useHead(() => {
	const href = pcBase;
	return {
		link: href ? [{ rel: 'canonical', href }] : [],
	};
});

// 滚动位置
const scrollTop = ref(0);
const searchKey = ref('');
const swiperDotRef = ref(null);
const queryParams = ref({
	companyId: 1,
	pageSize: 50,
	pageNumber: 1,
});

// 仅服务端请求，客户端直接用 payload 注水数据，不重复请求
const asyncDataOpts = { server: true, client: false };

// 统一判断接口成功（兼容 code 为 200 或 '200'），避免 SEO 渲染不一致
function isOk(res) {
	return res != null && (res.code === 200 || res.code === '200');
}

const floorParams = { source: 1, terminalType: 0, companyId: 1, logoOnly: 1 };
const recommendParams = { type: 1, companyCode: '', currentProductList: [], limit: 18 };

const [
	{ data: newsData },
	{ data: qualityNoticeData },
	{ data: kingkongData },
	{ data: operateAdData },
	{ data: bannerData },
	{ data: opSpuData },
	{ data: floorData },
	{ data: recommendData },
	{ data: topStoryData },
] = await Promise.all([
	useAsyncData('home-news-list', () => getHotNews({ companyId: 1, pageSize: 5, theTt: 1, pageNumber: 1, theMaster: 1 }), asyncDataOpts),
	useAsyncData('home-quality-notice-list', () => getHotNews({ theTt: 2, pageSize: 5, pageNum: 1, pageNumber: 1, companyId: 1 }), asyncDataOpts),
	useAsyncData('home-kingkong', () => getMbKingkongAreaList({}), asyncDataOpts),
	useAsyncData('home-operate-ad', () => getMbOperateAdList({}), asyncDataOpts),
	useAsyncData('home-banner', () => getMbBannerAdList({}), asyncDataOpts),
	useAsyncData('home-op-spu', () => mbOpSpuQuery({}), asyncDataOpts),
	useAsyncData('home-floor', () => queryFloorByThemeIdForMb(floorParams), asyncDataOpts),
	useAsyncData('home-recommend', () => recommendProducts(recommendParams), asyncDataOpts),
	useAsyncData('home-top-story', () => gxzzMallQueryPage({ pageStart: 1, pageSize: 5 }), asyncDataOpts),
	// TEMP: 国械标讯改客户端请求，先屏蔽 SSR/SEO（测完改回下方 useAsyncData，并放回上方解构）
	// useAsyncData('home-tender-notice', () => searchNotice(), asyncDataOpts),
]);

// TEMP: 标讯仅客户端；恢复 SSR 时删掉本段，改回 Promise.all 里的 useAsyncData
const tenderNoticeData = ref(null);

const newsList = computed(() => {
	const res = newsData.value;
	if (!isOk(res)) return [];
	return res?.data?.list ?? [];
});

const noticeList = computed(() => {
	const res = qualityNoticeData.value;
	if (!isOk(res)) return [];
	return res?.data?.list ?? [];
});

const navigationList = computed(() => (isOk(kingkongData.value) ? (kingkongData.value?.data ?? []) : []));

const operateAdList = computed(() => (isOk(operateAdData.value) ? (operateAdData.value?.data?.items ?? []) : []));

const bannerView = computed(() => {
	const res = bannerData.value;
	if (!isOk(res) || !res?.data?.length) return {};
	return res.data[0] ?? {};
});
const bannerImageUrl = computed(() => {
	const b = bannerView.value;
	return b?.imgUrl || b?.imageUrl || b?.mapUrl || b?.pictureUrl || b?.url || '';
});
const homeBannerHref = computed(() => {
	const b = bannerView.value;
	return b?.mobileLinkUrl || b?.linkUrl || b?.url || 'javascript:void(0)';
});
const homeBannerAlt = computed(() => bannerView.value?.title || bannerView.value?.columnTitleName || '首页专题');

const dataList = computed(() => (isOk(opSpuData.value) ? (opSpuData.value?.data ?? []) : []));

const logoList = computed(() => {
	const res = floorData.value;
	if (!isOk(res) || !Array.isArray(res?.data)) return [];
	return res.data.reduce((pre, cur) => {
		(cur.channelList || []).forEach(chanel => {
			(chanel.logoList || []).forEach(logoItem => {
				if (logoItem.brandTitle && logoItem.fileList?.length > 0) {
					pre.push({
						pictureUrl: logoItem.fileList[0].url,
						brandTitle: logoItem.brandTitle,
					});
				}
			});
		});
		return pre;
	}, []);
});

const recommendList = computed(() => (isOk(recommendData.value) ? (recommendData.value?.data ?? []) : []));

const tenderNoticeList = computed(() => {
	if (!isOk(tenderNoticeData.value)) return [];
	return (tenderNoticeData.value?.data || []).slice(0, 50);
});

const topStoryList = computed(() => {
	const res = topStoryData.value;
	if (!isOk(res)) return [];
	return (res?.data?.list ?? []).slice(0, 5);
});

/** TEMP: 国械标讯改为纯客户端请求（原 SSR 为空再兜底的逻辑先不用） */
async function fetchTenderNoticeClient() {
	if (!import.meta.client) return;
	try {
		const res = await searchNotice();
		if (isOk(res)) {
			tenderNoticeData.value = res;
		}
	} catch {
		// 请求失败展示空状态占位
	}
}

// /** SSR 标讯为空时客户端兜底（浏览器直连 API，避免服务端 IP 透传异常导致无数据） */
// async function fetchTenderNoticeClientFallback() {
// 	if (!import.meta.client || tenderNoticeList.value.length > 0) return;
// 	try {
// 		const res = await searchNotice();
// 		if (isOk(res)) {
// 			tenderNoticeData.value = res;
// 		}
// 	} catch {
// 		// 兜底失败展示空状态占位
// 	}
// }

/** 总站首页点击埋点统一入口 */
function trackPortalHomepageClick({ attrName, attrCode = 'button_name', companyCode, companyName, ext1, ext2 } = {}) {
	trackEvent({
		...(companyCode != null && companyCode !== '' && { companyCode }),
		...(companyName != null && companyName !== '' && { companyName }),
		module: '总站首页',
		eventCode: 'portal_homepage_click',
		eventName: '总站首页点击',
		attrCode,
		attrName,
		...(ext1 != null && ext1 !== '' && { ext1 }),
		...(ext2 != null && ext2 !== '' && { ext2 }),
	});
}

const clickGuessLike = productInfo =>
	trackPortalHomepageClick({
		attrName: '猜你喜欢',
		companyCode: productInfo.companyCode,
		companyName: productInfo.companyName,
		ext1: productInfo.productCode,
		ext2: productInfo.productName,
	});

const clickOperatorGrade = productInfo =>
	trackPortalHomepageClick({
		attrName: '运营商品位',
		companyCode: productInfo.companyCode,
		companyName: productInfo.companyName,
		ext1: productInfo.productCode,
		ext2: productInfo.productName,
	});

const onSearchBarClick = () => trackPortalHomepageClick({ attrName: '搜索' });

const onNavigationClick = () => trackPortalHomepageClick({ attrName: '金刚区' });

const onOperateAdClick = () => trackPortalHomepageClick({ attrName: '运营广告' });

const onSwiperBannerClick = ({ attrCode } = {}) =>
	trackPortalHomepageClick({
		attrName: '主banner',
		attrCode: attrCode || 'button_name',
	});

const trackTenderClick = attrCode => {
	trackEvent({
		module: '总站首页',
		eventCode: 'portal_homepage_click',
		eventName: '总站首页点击',
		attrName: 'button_name',
		attrCode,
		ext4: '国械标讯',
	});
};

const onTenderClickMore = () => {
	trackTenderClick('国械标讯更多');
	handleTenderNoticeJump({ portraitMobileUrl });
};

const onTenderToDetail = item => {
	trackTenderClick('国械标讯详情');
	handleTenderNoticeJump({ item, portraitMobileUrl });
};

const trackTopStoryClick = attrCode => {
	trackEvent({
		module: '总站首页',
		eventCode: 'portal_homepage_click',
		eventName: '总站首页点击',
		attrName: 'button_name',
		attrCode,
		ext4: '国械头条',
	});
};

const onTopStoryClickMore = () => {
	trackTopStoryClick('国械头条更多');
	// 国械智造总站头条列表
	navigateTo('/gxzz/topstory');
};

// 国械头条条目点击埋点（跳转由组件按渲染好的 href 完成）
const onTopStoryToDetail = () => {
	trackTopStoryClick('国械头条详情');
};

// 滚动处理
const handleScroll = () => {
	scrollTop.value = window.scrollY || document.documentElement.scrollTop;
};

// 页面挂载时初始化数据
onMounted(async () => {
	useWeixin().autoInit();
	window.addEventListener('scroll', handleScroll);

	trackEvent({
		module: '总站首页',
		eventCode: 'portal_homepage_enter',
		eventName: '进入总站首页',
	});

	await fetchTenderNoticeClient();
	await nextTick();
	if (tenderNoticeList.value.length > 0) {
		trackEventExposure('.tender-news', {
			module: '总站首页',
			eventCode: 'portal_module_exposure',
			eventName: '总站首页模块曝光',
			attrCode: 'module_name',
			attrName: '国械标讯',
		});
	}

	if (topStoryList.value.length > 0) {
		trackEventExposure('.top-story', {
			module: '总站首页',
			eventCode: 'portal_module_exposure',
			eventName: '总站首页模块曝光',
			attrCode: 'module_name',
			attrName: '国械头条',
		});
	}

	trackEventExposure('.guess-like', {
		module: '总站首页',
		eventCode: 'portal_module_exposure',
		eventName: '总站首页模块曝光',
		attrCode: 'module_name',
		attrName: '猜你喜欢',
	});
});

onUnmounted(() => {
	window.removeEventListener('scroll', handleScroll);
	disconnectAllExposure();
});

const searchPageRoute = {
	path: '/category/search',
	query: {
		placeholders: '产品名称/型号规格/厂家/商品描述',
		companyId: 1,
	},
};

const goToLink = () => {
	const b = bannerView.value;
	const link = b?.mobileLinkUrl || b?.linkUrl || b?.url;
	if (link) {
		trackPortalHomepageClick({ attrName: '横幅广告' });
		if (link.startsWith('http')) {
			window.open(link, '_blank');
		} else {
			window.location.href = link;
		}
	}
};
</script>

<style scoped lang="scss">
.container-home {
	padding-bottom: calc(4.17rem + env(safe-area-inset-bottom));
	font-size: 1rem;
	line-height: 2rem;
	background: #f3f4f6;

	.header {
		margin-top: 2px;
		padding: 0 8px;
	}

	.title {
		padding: 0.8rem 1.5rem 0;
		line-height: 1rem;
		color: #46539d;
		font-size: 1rem;

		text {
			&::before {
				position: relative;
				top: -0.2rem;
				content: '';
				display: inline-block;
				margin-right: 0.5rem;
				width: 0.5rem;
				height: 0.5rem;
				border-radius: 50%;
				background: #7f90f5;
			}
		}
	}
}

.all {
	color: #909399 !important;
}

.gap-bottom {
	margin-bottom: 8px;
}

/* 咨询模块：左右与轮播对齐，上下与其它模块一致 */
.zixun-layout {
	padding: 0 8px;
	margin-top: 6px;
	margin-bottom: 6px;
}

.gykx {
	padding: 0.5rem 1.83rem 0.5rem 1rem;
	background: #fff;
	border-radius: 5px;
	padding-right: 0;

	img {
		width: 61.92px;
		height: 14px;
	}

	.lunbo {
		width: 18.25rem;
		height: 1.5rem;
		margin-left: 1.5rem;
		overflow: hidden;

		:deep(.van-swipe-item) {
			display: flex;
			align-items: center;
		}

		.text {
			font-family: NotoSansSC-Regular, NotoSansSC;
			font-weight: 400;
			font-size: 13px;
			color: #606375;
			line-height: 18.2px;
			overflow: hidden;
			text-overflow: ellipsis;
			word-break: break-all;
			white-space: nowrap;
		}
	}

	.icon-gongneng_xiangyou-37 {
		font-size: 1rem;
		color: #909399;
	}
}

.search-top-wrap {
	background: #fff;
	padding: 5px 8px;
}

.search-top {
	border: 1.5px solid #455bd9;
	border-radius: 7px;
	align-items: center;
	display: flex;
	height: 34px;
	padding: 2px 1px 2px 2px;

	background: #fff;

	&.search-top-link {
		text-decoration: none;
	}

	.search-input {
		color: #595959;
		font-size: 12px;
		flex: 1;
		padding-left: 10px;
		padding-right: 10px;
		caret-color: transparent;
		/* 隐藏闪烁光标 */
		cursor: pointer;
	}

	.search-btn {
		border-radius: 5px;
		width: 60px;
		height: 30px;
		background: #455bd9;
		font-size: 13px;
		font-weight: 500;
		font-variation-settings: 'opsz' auto;
		color: #ffffff;
		display: flex;
		align-items: center;
		justify-content: center;
		white-space: nowrap;
	}
}

.bg-top-v {
	background: linear-gradient(180deg, #ffffff 0%, #f2f4fa 100%) !important;
	padding-top: 6px;
}

.bg-botom-v {
	background: #f5f5f5;
}

.main-wrap {
	padding: 0 8px;
	margin-bottom: 8px;
	background: #f5f5f5;
}

.web-banner-box {
	width: 100%;
	padding: 0 8px;
	margin-bottom: 8px;
}

.web-banner-img {
	display: block;
	width: 100%;
	height: auto;
	border-radius: 5px;
}

.web-banner-link {
	display: block;
}
</style>
